<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "ForecastReportIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
